import { ActionService } from 'dashboard-services/services';

export default (() => {
  const CHANGE_VALUE = 'CHANGE_VALUE_COPY_MODAL_DATA_STORAGE'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  const SET_ERRORS = 'SET_ERRORS_COPY_MODAL_DATA_STORAGE'
  const setErrors = ActionService.makeActionCreator(SET_ERRORS, 'errors')

  return {
    changeValue,
    CHANGE_VALUE,
    SET_ERRORS,
    setErrors
  }
})()